<template>
  <div>
    <div class="outgoing-detail" v-if="items != null">
      <Toast />

      <div class="card">
        <table style="width: 100%">
          <thead>
            <!-- HEADER -->
            <div class="card">
              <div class="p-d-flex">
                <div class="p-col-10 p-grid">
                  <div class="p-col-1 image">
                    <img src="/assets/images/logo.png" alt="mode_logo" />
                  </div>
                  <div
                    class="p-col-10"
                    style="margin-top: -10px; margin-left: -5px"
                  >
                    <h4 style="font-size: 15px; line-height: 0.5">
                      <b>MODE FASHION GROUP</b>
                    </h4>
                    <h6 style="font-size: 11px; line-height: 0.5">
                      {{ outlet.name }}
                    </h6>
                    <h6 style="font-size: 11px; line-height: 0.5">
                      Telp. (061) 6643780
                    </h6>
                  </div>
                </div>
              </div>
            </div>
            <div class="border-header" style="margin-bottom: 30px"></div>
            <!-- akhir header -->
          </thead>
          <tbody>
            <h4 class="title" style="margin-bottom: 20px; margin-top: -20px">
              <b style="font-size: 14px"
                >LAPORAN KONDISI STOK BARANG TAHUN {{ $route.query.year }}</b
              >
            </h4>

            <div class="p-grid">
              <div class="p-col-12 p-m-auto">
                <!-- content part -->
                <table
                  border="1"
                  class="text-center detail-bon"
                  style="width: 100%"
                >
                  <thead style="font-size: 12px; background-color: #ddd">
                    <tr>
                      <th scope="col" class="text-center" rowspan="2">
                        Kelompok Barang
                      </th>
                      <th scope="col" class="text-center" rowspan="2">
                        Nama Barang
                      </th>
                      <th scope="col" class="text-center" rowspan="2">Qty</th>
                    </tr>
                  </thead>
                  <tbody style="font-size: 11px" class="header">
                    <tr v-for="(item, k) in items" :key="k" class="row-content">
                      <td>{{ item.cat_code }}</td>
                      <td>{{ item.cat_name }}</td>
                      <td>{{ item.qty }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ModeLogo: undefined,
      items: null,
      outlet: null
    }
  },

  mounted() {
    this.getOutlet()
    this.getItemsCondition()
  },

  methods: {
    getOutlet() {
      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/outlets/${this.$route.query.outlet_id}`
        )
        .then(response => {
          if (response.status === 200) {
            this.outlet = response.data.data.outlets
          }
        })
    },

    getItemsCondition() {
      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/report/year-stock?year=${this.$route.query.year}`
        )
        .then(response => {
          if (response.status === 200) {
            this.loading = false
            this.items = response.data.data.category
          }
        })
    }
  }
}
</script>
<style scoped lang="scss">
table {
  -fs-table-paginate: paginate;
}

table thead th {
  border: 1px solid black;
}

.container {
  font-family: monospace;
  width: 100%;
  margin-top: -50px;
  margin-left: auto; /* to center the div */
  margin-right: auto; /* to center the div */
  box-sizing: border-box;
  overflow: hidden;
}

.border-header {
  border-top: 2px solid black;
  width: 95%;
  margin-top: -4vh;
  margin-left: auto;
  margin-right: auto;
  justify-content: center;
}

.image {
  margin-top: -7px;
  width: 63px;
}

.title {
  text-align: center;
}

.outgoing-detail {
  font-family: monospace;
  width: 100%;
  margin-top: -50px;
  margin-left: auto; /* to center the div */
  margin-right: auto; /* to center the div */
  box-sizing: border-box;
  overflow: hidden;
}

@media print {
  .detail-bon {
    border: 1px solid black;
    border-collapse: collapse;
  }

  .detail-bon th,
  .detail-bon td {
    border: 1px solid black;
  }

  .detail-bon thead {
    background-color: #ddd !important;
    -webkit-print-color-adjust: exact !important;
  }
}
</style>
